export const EVENTS = {
    errors: {
        leitura: {
            pdf: 'ErroLeituraPdf'
        }
    }
}

